import { TOP_PADDING_FROM_TOOLBAR, BOTTOM_PADDING_FROM_VIEW } from 'crazyEditor/core/constants/editorConstants';

export default {
  visible: {
    display: 'block'
  },
  hidden: {
    display: 'none'
  },
  templateWrapper: {
    paddingTop: TOP_PADDING_FROM_TOOLBAR,
    paddingBottom: BOTTOM_PADDING_FROM_VIEW
  }
};
